var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import BarChartIcon from "@mui/icons-material/BarChart";
import DeleteIcon from "@mui/icons-material/Delete";
import EditIcon from "@mui/icons-material/Edit";
import { Box, Card, CardContent, CardHeader, Grid, Stack, Typography, useMediaQuery, useTheme, } from "@mui/material";
import React from "react";
import { Link, useNavigate } from "react-router-dom";
import { useDeleteIntraSquadMatch } from "../api/IntraSquadMatchApiProvider";
import { useRetrieveUserIntraSquadMatchPermissions } from "../api/PermissionApiProvider";
import { useRetrieveIntraSquadMatch, useRetrievePlayersByTeamId, useRetrieveTeam, useRetrieveTeamPreferences, } from "../ApiProvider";
import { ErrorView } from "../nav/Error";
import { Loading } from "../nav/Loading";
import { NotFound } from "../nav/NotFound";
import { findPlayerById } from "../players/utils";
import { formatScorer } from "../stats/ScorerFormatter";
import { findPlayerIntraSquadMatchStatByPlayerId } from "../stats/utils";
import { SquadCard } from "../teams/SquadCard";
import { DeleteDialog } from "../utils/DeleteDialog";
import ErrorSnackbar from "../utils/ErrorSnackbar";
import { ResponsiveActionMenu, } from "../utils/ResponsiveActionMenu";
import { useNumericParams } from "../utils/useNumericParams";
import { MatchDateTimeHeader } from "./MatchDateTimeHeader";
import { MatchScoreboard } from "./MatchScoreboard";
var IntraSquadMatch = function () {
    var _a, _b, _c, _d;
    var id = useNumericParams().id;
    var navigate = useNavigate();
    var _e = __read(React.useState(false), 2), showDelete = _e[0], setShowDelete = _e[1];
    var theme = useTheme();
    var isMobile = useMediaQuery(theme.breakpoints.down("sm"));
    var _f = useRetrieveUserIntraSquadMatchPermissions({ intraSquadMatchId: id }), userIntraSquadMatchPermissions = _f.data, userIntraSquadMatchPermissionsIsLoading = _f.isLoading, userIntraSquadMatchPermissionsError = _f.error;
    var _g = userIntraSquadMatchPermissions || {}, _h = _g.canModify, canModify = _h === void 0 ? false : _h, _j = _g.canView, canView = _j === void 0 ? false : _j, _k = _g.canModifyStats, canModifyStats = _k === void 0 ? false : _k;
    var _l = useRetrieveIntraSquadMatch({ id: id, enabled: canView }), intraSquadMatchIsLoading = _l.isLoading, intraSquadMatchError = _l.error, intraSquadMatch = _l.data;
    var _m = useRetrieveTeam({ id: intraSquadMatch === null || intraSquadMatch === void 0 ? void 0 : intraSquadMatch.team }), useRetrieveTeamIsLoading = _m.isLoading, useRetrieveTeamError = _m.error, team = _m.data;
    var mutation = useDeleteIntraSquadMatch({
        intraSquadMatch: intraSquadMatch,
        team: team,
        onMutate: function () { },
        onSuccess: function () {
            return navigate("/teams/".concat(intraSquadMatch === null || intraSquadMatch === void 0 ? void 0 : intraSquadMatch.team));
        },
        onError: function () { },
    });
    var _o = useRetrieveTeamPreferences({ teamId: intraSquadMatch === null || intraSquadMatch === void 0 ? void 0 : intraSquadMatch.team }), useRetrieveTeamPreferenceIsLoading = _o.isLoading, useRetrieveTeamPreferenceError = _o.error, teamPreference = _o.data;
    var _p = useRetrievePlayersByTeamId({ teamId: intraSquadMatch === null || intraSquadMatch === void 0 ? void 0 : intraSquadMatch.team }), players = _p.data, playersError = _p.error, playersIsLoading = _p.isLoading;
    var getPlayer = findPlayerById(players || []);
    var getPlayerIntraSquadMatchStat = findPlayerIntraSquadMatchStatByPlayerId((intraSquadMatch === null || intraSquadMatch === void 0 ? void 0 : intraSquadMatch.playerIntraSquadMatchStats) || []);
    var teamAPlayers = (_a = intraSquadMatch === null || intraSquadMatch === void 0 ? void 0 : intraSquadMatch.teamAPlayers) === null || _a === void 0 ? void 0 : _a.map(getPlayer).filter(function (player) { return player !== undefined; });
    var teamBPlayers = (_b = intraSquadMatch === null || intraSquadMatch === void 0 ? void 0 : intraSquadMatch.teamBPlayers) === null || _b === void 0 ? void 0 : _b.map(getPlayer).filter(function (player) { return player !== undefined; });
    var teamAScorers = teamAPlayers === null || teamAPlayers === void 0 ? void 0 : teamAPlayers.map(function (player) {
        var stats = getPlayerIntraSquadMatchStat(player.id);
        return formatScorer(player, stats);
    }).filter(function (scorer) { return scorer !== undefined; });
    var teamBScorers = teamBPlayers === null || teamBPlayers === void 0 ? void 0 : teamBPlayers.map(function (player) {
        var stats = getPlayerIntraSquadMatchStat(player.id);
        return formatScorer(player, stats);
    }).filter(function (scorer) { return scorer !== undefined; });
    if (userIntraSquadMatchPermissionsIsLoading) {
        return _jsx(Loading, {});
    }
    if (!canView) {
        return _jsx(NotFound, {});
    }
    if (userIntraSquadMatchPermissionsError) {
        return _jsx(ErrorView, { error: userIntraSquadMatchPermissionsError });
    }
    if (intraSquadMatchIsLoading ||
        mutation.isLoading ||
        playersIsLoading ||
        useRetrieveTeamPreferenceIsLoading ||
        useRetrieveTeamIsLoading) {
        return _jsx(Loading, {});
    }
    if (id === undefined) {
        return _jsx(NotFound, {});
    }
    if (useRetrieveTeamError ||
        intraSquadMatchError ||
        useRetrieveTeamPreferenceError ||
        playersError ||
        !intraSquadMatch ||
        !teamPreference ||
        !team) {
        return _jsx(ErrorView, {});
    }
    var handleCloseDeleteDialog = function () {
        setShowDelete(false);
    };
    var handleDelete = function () {
        mutation.mutate();
    };
    var actions = __spreadArray(__spreadArray([], __read((canModify || canModifyStats
        ? [
            {
                icon: _jsx(BarChartIcon, {}),
                label: "Edit Stats",
                to: "/teams/".concat(team.id, "/intra-squad-matches/").concat(id, "/stats/update/"),
            },
        ]
        : [])), false), __read((canModify
        ? [
            {
                icon: _jsx(EditIcon, {}),
                label: "Edit Match",
                to: "/teams/".concat(team.id, "/intra-squad-matches/").concat(id, "/update"),
            },
            {
                icon: _jsx(DeleteIcon, {}),
                label: "Delete",
                onClick: function () { return setShowDelete(true); },
            },
        ]
        : [])), false);
    return (_jsxs(React.Fragment, { children: [_jsx(ErrorSnackbar, { open: mutation.isError, message: "Failed to delete match. Please try again!" }), _jsx(DeleteDialog, { open: showDelete, title: "Delete Intra-Squad Match?", onCancel: handleCloseDeleteDialog, onConfirm: handleDelete }), _jsxs(Card, { sx: { mb: 3 }, children: [_jsx(CardHeader, { title: _jsxs(Stack, { direction: "row", alignItems: "center", justifyContent: "space-between", children: [_jsx(Box, { sx: { flex: 1 } }), _jsx(MatchDateTimeHeader, { kickOff: intraSquadMatch.kickOff, subtitle: _jsx(Link, { style: { textDecoration: "none" }, to: "/teams/".concat(team.id), children: _jsx(Typography, { variant: "body2", color: "primary.main", sx: { "&:hover": { textDecoration: "underline" } }, children: team.name }) }) }), _jsx(Box, { sx: { flex: 1, display: "flex", justifyContent: "flex-end" }, children: (canModify || canModifyStats) && (_jsx(ResponsiveActionMenu, { actions: actions, isMobile: isMobile })) })] }) }), _jsx(CardContent, { children: _jsx(MatchScoreboard, { team1: { name: teamPreference.teamAName }, team2: { name: teamPreference.teamBName }, score1: (_c = intraSquadMatch.intraSquadMatchResult) === null || _c === void 0 ? void 0 : _c.teamAScore, score2: (_d = intraSquadMatch.intraSquadMatchResult) === null || _d === void 0 ? void 0 : _d.teamBScore, scorers1: teamAScorers, scorers2: teamBScorers }) })] }), _jsxs(Grid, { container: true, spacing: 2, children: [_jsx(Grid, { item: true, xs: 12, md: 6, children: _jsx(SquadCard, { title: _jsx(Typography, { align: "center", variant: "subtitle2", children: teamPreference.teamAName }), players: teamAPlayers || [] }) }), _jsx(Grid, { item: true, xs: 12, md: 6, children: _jsx(SquadCard, { title: _jsx(Typography, { align: "center", variant: "subtitle2", children: teamPreference.teamBName }), players: teamBPlayers || [] }) })] })] }));
};
export default IntraSquadMatch;
